﻿import React, { useState, useEffect } from 'react';
import { Product } from '../../models/product';
import { LookupItem } from '../../models/lookup-item';
import { CrudFunctions } from '../../utilities/crud-functions';
import { PWDates } from '../../utilities/pw-dates';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    FilterRow,
    GroupPanel,
    Selection,
    HeaderFilter,
    Editing,
    Toolbar,
    Item as ToolBarItem,
    Button as ColumnButton,
    Paging,
    Scrolling,
    Lookup,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Toast } from 'devextreme-react/toast';

export default function DynamicsItemsPreparationForm() {
    const [itemGroups, setItemGroups] =
        useState<LookupItem[]>();

    const [selectedItemGroup, setSelectedItemGroup] =
        useState<LookupItem>();

    const [products, setProducts] =
        useState<Product[]>();

    const [selectedProduct, setSelectedProduct] =
        useState<Product>();

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        if (!dataLoaded)
            getAllData();
    }, []);

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Dynamics Items Preparation</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back" className="title-bar-button"
                            height={'2.6em'}
                            onClick={goBack} />
                    </div>
                </div>
            </div>

            <div className="pw-margin-bottom-1">
                <DataGrid height="20rem" width="100%"
                    dataSource={products ? products : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    onSelectionChanged={onItemsSelectionChanged}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}
                    keyExpr="productId">

                    {/*
                        onRowValidating={onItemsRowValidating}
                       
                        */}

                    <LoadPanel enabled={true} />
                    <Paging enabled={false} />
                    <Selection mode={'single'} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <GroupPanel visible={true} />
                    <SearchPanel visible={true} />
                    <Scrolling columnRenderingMode={'virtual'} />

                    {/*
                        <Column type="buttons" width={"5rem"}>
                            <ColumnButton name="edit" />
                            <ColumnButton hint="audit information" icon="clock"
                                onClick={onGlasswareAuditButtonClicked} />
                            <ColumnButton hint="information" icon="info"
                                onClick={onGlasswareInformationButtonClicked} />
                        </Column>
                        */}

                    <Column dataField='name' caption="Part Number" width='10rem' />

                    <Column dataField='itemGroup' width='12rem'>
                        <Lookup dataSource={itemGroups}
                            allowClearing={true}
                            valueExpr='id'
                            displayExpr='name' />
                    </Column>

                    <Column dataField='displayName' width='20rem' />
                    <Column dataField='casNumber' caption="CAS #" width='8rem' />
                    <Column dataField='packSize' width='6rem' dataType="number" />
                    <Column dataField='packSizeUom' caption="UOM" width='6rem' dataType="string" />
                    <Column dataField='expiration' width='6rem' dataType="number" />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Products / Item</div>
                            </div>
                        </ToolBarItem>
                        <ToolBarItem location="after" name="addRowButton" />
                    </Toolbar>

                    <Editing
                        mode="row"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true} >

                    </Editing>
                </DataGrid>
            </div>

            <div>
                <DataGrid height="20rem" width="100%"
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    dataSource={itemGroups ? itemGroups : []}
                    onInitNewRow={onItemGroupsInitNewRow}
                    onSelectionChanged={onSelectedItemGroupItemChanged}

                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}
                    keyExpr='id' >

                    {/* 
                         onRowValidating={onItemGroupDatagridRowValidating}
                        onRowRemoving={onItemGroupRowRemoving}                        
                        */}


                    <LoadPanel enabled={true} />
                    <Selection mode='single' />
                    <Paging enabled={false} />
                    <Scrolling showScrollbar="always" columnRenderingMode={'virtual'} />

                    {/*
                        <Column type="buttons" width={110}>
                            <ColumnButton name="edit" />
                            <ColumnButton name="delete" />
                            <ColumnButton hint="certificate" icon="bookmark"
                                onClick={showGlasswareCertificatesDialog} />
                            <ColumnButton hint="audit information" icon="clock"
                                onClick={onGlasswareItemsAuditButtonClicked} />
                            <ColumnButton hint="information" icon="info"
                                onClick={onGlasswareItemsInformationButtonClicked} />
                        </Column>
                        */}

                    <Column dataField='name' width='10rem' dataType="string" />
                    <Column dataField='description' caption="Description" dataType="string" />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Item Groups</div>
                            </div>
                        </ToolBarItem>
                        <ToolBarItem location="after" name="addRowButton" />
                    </Toolbar>

                    <Editing
                        mode="row"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true} >

                    </Editing>
                </DataGrid>
            </div>

            <DmaFooter />

            <Toast
                visible={toastVisible}
                message={toastMessage}
                type={toastType}
                onHiding={onToastHiding}
                displayTime={600}
            />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function onToastHiding() {
        setToastVisible(false);
        setToastMessage(undefined);
        setToastType(undefined);
    }

    function showToast(message: string, toastType: string) {
        setToastMessage(message);
        setToastType(toastType);
        setToastVisible(true);
    }


    //change

    function onItemsSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedProduct(e.selectedRowsData[0]);
    }

    function onSelectedItemGroupItemChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedItemGroup(e.selectedRowsData[0]);
    }

    // validating

    async function onItemsRowValidating(e: any) {
        if (dataLoaded)
            return;

        /*
    if (e.oldData) {
        let glassware = e.oldData as Glassware;

        if (glassware) {
            let updatedGlassware = { ...glassware, ...e.newData };
            await updateGlassware(updatedGlassware)
                .then(() => {
                    showToast("Glassware updated", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Glassware");
                });
        }
    }
    */
    }

    function onItemGroupsInitNewRow(e: any) {

        if (itemGroups) {
            let numberItemGroups = itemGroups.length;

            let newItemGroup: LookupItem = {
                id: numberItemGroups + 1,
            };

            e.data = newItemGroup;
        }
    }

    async function onItemGroupDatagridRowValidating(e: any) {
        //console.log("onGlasswareItemsDatagridRowValidating");
        //console.log(e);

        if (!dataLoaded)
            return;

        /*
    if (e.oldData) {
        let glasswareItem = e.oldData as GlasswareItem;

        if (glasswareItem) {
            let updatedGlasswareItem = { ...glasswareItem, ...e.newData };

            updateGlasswareItem(updatedGlasswareItem)
                .then(() => {
                    showToast("Glassware Item updated", "success");
                    getGlasswareItems();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Glassware Item");
                });
        }
    }
    else {
        if (e.newData) {
            let glasswareItem = e.newData as GlasswareItem;

            if (glasswareItem && selectedGlassware && selectedGlassware.glasswareId) {
                glasswareItem.glasswareId = selectedGlassware.glasswareId;

                await insertGlasswareItem(glasswareItem)
                    .then(() => {
                        showToast("Glassware Item saved", "success");
                        getGlasswareItems();
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Glassware Item");
                    });
            }
        }
    }
    */
    }

    // delete

    function onItemGroupRowRemoving(e: any) {
        /*
        if (e.data && e.data.glasswareItemId)
            deleteGlasswareItem(e.data.glasswareItemId)
                .then(() => {
                    showToast("Glassware Item deleted", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Glassware Item");
                });
                */

    }

    // get functions

    /*
    async function getGlassware() {
        await CrudFunctions.getData("common/glassware")
            .then(data => {
                setGlassware(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Glassware");
            });
    }

    async function getGlasswareItems() {
        if (selectedGlassware && selectedGlassware.glasswareId)
            await CrudFunctions.getData(`common/glasswareitems/${selectedGlassware.glasswareId}`)
                .then(data => {
                    setGlasswareItems(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Glassware Items");
                });
    }

    async function getGlasswareTypes() {
        await CrudFunctions.getData("common/glasswaretypes")
            .then(data => {
                setGlasswareTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Glassware Types");
            });
    }
    


    //POST functions

    async function insertGlasswareItem(glasswareItem: GlasswareItem) {
        return CrudFunctions.postData("common/glasswareitem", glasswareItem);
    }

    
    async function insertGlasswareCertificate(document: Document) {
        return await CrudFunctions.postData("media/document", document);
    }
    

    //PUT functions

    async function updateGlassware(glassware: Glassware) {
        return CrudFunctions.putData("common/glassware", glassware);
    }

    async function updateGlasswareItem(glasswareItem: GlasswareItem) {
        return CrudFunctions.putData("common/glasswareitem", glasswareItem);
    }

    // DELETE functions

    async function deleteGlasswareItem(glasswareItemId: string) {
        return CrudFunctions.deleteData(`common/glasswareitem/${glasswareItemId}`);
    }

    
    async function deleteGlasswareCertificate(documentId: string) {
        return await CrudFunctions.deleteData(`media/document/${documentId}`);
    }
    */
    //navigation

    function goBack() {
        history.back();
    }

    //render


    async function getAllData() {
        await Promise.all([
            //await getGlasswareTypes(),
            //await getGlassware(),
        ])
            .then(() => {
                setDataLoaded(true);
            });
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
